import type { RouteRecordRaw } from 'vue-router'

import { registeredReportPages, type ReportPageDefinition } from './configs/pages'
import { registerReportMessages } from './i18n'

import { DEFAULT_LOCALE, SUPPORTED_LOCALES, i18n, type SupportedLocale } from '@/shared/i18n'

// Every manifest row becomes one child of the authenticated '/' parent (contract 05 §11),
// rendering the shared ReportPage host with row-derived props — v3's per-page view wrapper
// files die. Paths and names keep v3 parity (deep links survive the cutover).

function activeLocale(): SupportedLocale {
  const locale = i18n.global.locale.value
  return (SUPPORTED_LOCALES as readonly string[]).includes(locale)
    ? (locale as SupportedLocale)
    : DEFAULT_LOCALE
}

function toRoute(page: ReportPageDefinition): RouteRecordRaw {
  return {
    path: page.path,
    name: page.routeName,
    component: () => import('./components/page/ReportPage.vue'),
    props: {
      layoutKey: page.layoutKey,
      reportIds: page.reportIds,
      ...(page.isNotTab ? { isNotTab: true } : {}),
      ...(page.updatedDateId !== undefined ? { updatedDateId: page.updatedDateId } : {}),
      ...(page.updatedTab !== undefined ? { updatedTab: page.updatedTab } : {}),
      ...(page.headerTitleKey ? { headerTitleKey: page.headerTitleKey } : {}),
      ...(page.headerSubtitleKey ? { headerSubtitleKey: page.headerSubtitleKey } : {}),
    },
    meta: { navKey: page.navKey, titleKey: page.titleKey },
    beforeEnter: async () => {
      await registerReportMessages(activeLocale())
    },
  }
}

export const reportRoutes: RouteRecordRaw[] = registeredReportPages().map(toRoute)
